<template>
  <div>
    <list
      row-key="OrderId"
      ref="list"
      unit="订单"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="订单编号">
          <el-input size="mini" v-model="params.OrderNo" placeholder="请输入订单编号" clearable />
        </el-form-item>
        <el-form-item label="客户名称">
          <customer  @restaurants='setSupplier' :state='params.CustomerName'/>
        </el-form-item>
        <el-form-item label="订单时间">
          <el-date-picker
            size="mini"
            v-model.trim="params.StartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.EndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择订单状态" clearable>
            <el-option label="本地" :value="1"></el-option>
            <el-option label="未确认" :value="0"></el-option>
            <el-option label="正常执行中" :value="1"></el-option>
            <el-option label="退款中" :value="2"></el-option>
            <el-option label="已完成" :value="3"></el-option>
            <el-option label="已取消" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发货状态">
          <el-select size="mini" v-model="params.SendStatus" placeholder="请选择发货状态" clearable>
            <el-option label="未发货" :value="0"></el-option>
            <el-option label="已发货" :value="1"></el-option>
            <el-option label="已收货" :value="2"></el-option>
            <el-option label="退货中" :value="3"></el-option>
            <el-option label="退货待收" :value="4"></el-option>
            <el-option label="已退货" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款状态">
          <el-select size="mini" v-model="params.PayStatus" placeholder="请选择付款状态" clearable>
            <el-option label="未付款" :value="0"></el-option>
            <el-option label="已付款" :value="1"></el-option>
            <el-option label="退款中" :value="2"></el-option>
            <el-option label="已退款" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款状态">
          <el-select size="mini" v-model="params.RefundStatus" placeholder="请选择退款状态" clearable>
            <el-option label="空" :value="0"></el-option>
            <el-option label="退款待审" :value="1"></el-option>
            <el-option label="客户取消" :value="2"></el-option>
            <el-option label="同意退款" :value="3"></el-option>
            <el-option label="拒绝退款" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属机构">
              <el-select size="mini" v-model="params.DpId" placeholder="请选择机构">
         
                  <el-option v-for="(item,key) in DpList" :key="key" :label="item.DpName" :value="item.DpId"></el-option>
           
              </el-select>
            </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="所属机构" min-width="100px" />
        <el-table-column prop="CustomerName" label="客户名称" min-width="170px" />
        <el-table-column prop="Address" label="客户信息" min-width="200px" show-overflow-tooltip />
        <el-table-column prop="OrderNo" label="订单编号" min-width="160px" />
        <el-table-column prop="Amount" label="订单总额" min-width="100px" />
        <el-table-column prop="AddTime" label="订单时间" min-width="100px">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.AddTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StatusText" label="订单状态" align="center" min-width="100px" />
        <el-table-column prop="SendStatusText" label="发货状态" align="center" min-width="100px" />
        <el-table-column prop="PayStatusText" label="付款状态" align="center" min-width="100px" />
        <el-table-column prop="RefundStatusText" label="退款状态" min-width="100px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: { list,customer },
  data() {
    return {
      api: require("@/api/mall/order").default,
      dpApi: require("@/api/ent/dp").default,
      params: {
        OrderNo: "",
        Status: 4, //订单状态
        SendStatus: null, //发货状态
        PayStatus: null, //付款状态
        RefundStatus: null, //退款状态
        CustomerType: 1,
        CustomerId:"",
        CustomerName:"",
        DpId:null,//所属门店
        StartTime:this.$commonJs.getDayOffset(-30),
        EndTime:this.$commonJs.getDayOffset(0)
      },
      DpList:[]
    };
  },
  created(){
    this.dpApi.parentList({DpType:1}).then(res => {
       
       this.DpList = res.Data;
     })
  },
  methods: {
    setSupplier(data) {
      
      this.params.CustomerId = data.TradeUnitId;
      this.params.CustomerName = data.TradeUnitName;
    },
    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>